// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pTdc","tabsBox":"styles_tabsBox__eG11j","createButton":"styles_createButton__1lWYe"};